export default {
    general: {
        january: 'januar',
        february: 'februar',
        march: 'marec',
        april: 'april',
        may: 'maj',
        june: 'junij',
        july: 'julij',
        august: 'avgust',
        september: 'september',
        october: 'oktober',
        november: 'november',
        december: 'december',
    },
    home: {
        motto: 'Zobozdravnica za otroke in odrasle s sočutnim, mirnim in obzirnim pristopom in strokovno podkovanostjo.',
        doctorTitle: 'dr. dent. med.',
        sections: {
            booking: 'Naročanje',
            workingHours: 'Delovni čas',
            team: 'Ekipa',
            services: 'Storitve',
            googleReviews: 'Google mnenja',
            followUs: 'Spremljajte nas na',
        },
        moreAboutUs: 'Več o nas...',
        pricelist: 'Cenik',
        contactForm: {
            title: 'Izpolnite obrazec',
            subtitle: ' in kmalu vas kontaktiramo!',
        },
        social: {
            facebookAriaLabel: 'Poglejte naš Facebook profil',
            instagramAriaLabel: 'Poglejte naš Instagram profil',
        },
    },
    workingHours: {
        mon: 'Pon',
        tueThu: 'Tor, Sre',
        wed: 'Čet',
        fri: 'Pet',
    },
    contactForm: {
        namePlaceholder: 'Ime',
        emailPlaceholder: 'E-mail',
        messagePlaceholder: 'Povejte, kako vam lahko pomagamo',
        send: 'Pošlji',
        sent: 'Poslano',
        sending: 'Pošiljanje v teku...',
        successTitle: 'Prejeli smo vaše sporočilo!',
        successSubtitle: 'V kratkem vas kontaktiramo!',
        errors: {
            nameRequired: 'Vnesite ime',
            nameTooShort: 'Ime je prekratko',
            nameTooLong: 'Ime je predolgo',
            emailRequired: 'Vnesite e-mail',
            emailInvalid: 'Vnesite veljaven e-mail',
            emailTooShort: 'E-mail je prekratek',
            emailTooLong: 'Email je predolg',
            messageRequired: 'Vnesite opis',
            messageTooShort: 'Opis je prekratek (vsaj 30 znakov)',
            messageTooLong: 'Opis je predolg (največ 5.000 znakov)',
            sendFailed:
                'Pošiljanje je bilo neuspešno.\nProsimo poskusite ponovno ali pa nas pokličite na telefonsko številko {phone}.',
        },
    },
    reviews: {
        reviewsCount: '{count} mnenj',
        connectionError: 'Napaka v povezavi.',
        writeReview: 'Napiši svoje mnenje!',
        ratingUnit: 'Ocena',
    },
    footer: {
        copyright: '© Sočutno zobozdravstvo d.o.o. {year}',
    },
    closedBanner: {
        text: 'Trenutno smo odsotni do',
        tomorrow: 'jutri',
        dayAfterTomorrow: 'pojutrišnjega',
    },
    article: {
        bookAppointment: 'Naročite se na pregled',
        back: 'Nazaj',
    },
    services: {
        ortopanBold: 'Ortopan',
        ortopanSuffix: 'rentgen',
        parodontologiaPrefix: 'Laserska',
        parodontologijaBold: 'parodontologija',
        endodontskoBold: 'Endodontsko',
        endodontskiSuffix: 'zdravljenje',
        myobrace: 'Myobrace',
        invisalign: 'Invisalign',
        beljenjeBold: 'Beljenje',
        beljenjeSuffix: 'zob',
        laskerskoBold: 'Lasersko',
        lasterskoSuffix: 'zdravljenje',
        frenulotomijaBold: 'Laserska',
        frenulotomijaSuffix: 'frenulotomija',
        protetikaBold: 'Mostički,',
        protetikaSuffix: 'prevleke',
        preglediPrefix: 'Zobozdravstveni',
        preglediBold: 'pregledi',
        otroskoBold: 'Otroško',
        otroskoSuffix: 'zobozdravstvo',
        kariesPrefix: 'Zdravljenje',
        kariesa: 'kariesa',
        injekcijskaTehnikaBold: 'Injekcijska',
        injekcijskaTehnikaSuffix: 'tehnika',
    },
    ekipa: {
        urska: {
            name: 'Urška Šavli',
            title: 'Doktorica dentalne medicine',
            quote: 'Veseli jo delo z ljudmi, klepetanje s pacienti in ponosna je na vsakogar, ki v Sočutnem zobozdravstvu premaga strah.',
        },
        katja: {
            name: 'Katja Cerar',
            title: 'Diplomirana medicinska sestra',
            quote: 'Med delom preverja, ali se pacient dobro počuti, če ima dvome ali skrbi in ga spodbuja. Pozna najboljše trike, da vam med posegi voda ne teče v grlo. Dobesedno!',
        },
    },
    articles: {
        pregledi: {
            title: 'Zobozdravstveni pregledi',
            intro: 'Opravljamo preglede zobovja, obzobnih tkiv in celotnih ust. Posebej pozorni smo na karies (zobno gnilobo) in vnetje dlesni (parodontozo). Povečevalne lupe nam omogočajo posebej natančen pregled in boljšo diagnostiko.',
            childrenTitle: 'Pregledi za otroke',
            childrenP1:
                'Za otroke priporočamo prvi pregled ob starosti eno leto, takrat prvič pregledamo zobke in se pogovorimo s starši o vzdrževanju higiene, prehrani in dodatkih. Odgovorimo na pogosta vprašanja in staršem zaupamo preverjene metode za lažje umivanje zob in boljše sodelovanje otrok.',
            childrenP2:
                'Otrok ne silimo v pregled, prilagodimo se njihovemu razpoloženju in tempu, z namenom da je izkušnja prijetna in se prihodnjič vrnejo z boljšim občutkom. Po pregledu čaka otroka drobna nagrada za vzpodbudo in pogum.',
            childrenP3: 'Za otroke priporočamo preventivne preglede na pol leta.',
            adultsTitle: 'Pregledi za odrasle',
            adultsP1:
                'Ob pregledu odraslih smo pozorni na znake <b>raka</b> ali <b>razjed</b> v ustni votlini, opazujemo <b>razvoj čeljusti</b>, nepravilne ali <b>škodljive razvade in navade</b>.',
            adultsP2ParodontalDisease: 'Parodontalna bolezen',
            adultsP2body:
                'je zelo zahrbtna bolezen, ki ne boli in ne kaže jasnih znakov, dokler niso zobje že majavi, takrat pa je za uspešno zdravljenje že prepozno. Posebno pozornost namenjamo pregledu obzobnih tkiv z merjenjem žepkov in opazovanjem prisotnosti krvavitve. Če bolezen zaznamo v zgodnjih fazah, pa jo uspešno zaustavimo in obvladamo.',
            adultsP3Xray: 'Rentgenski posnetek vseh zob - ORTOPAN',
            adultsP3body: 'nam je v veliko pomoč pri temeljiti diagnostiki in zaznavanju težav.',
            cenikPre: 'Cene zobozdravstvenih pregledov lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        karies: {
            title: 'Zdravljenje kariesa',
            intro: 'Karies ali zobna gniloba nastane zaradi delovanja ustnih bakterij, ki jih prekomerno "hranimo" s sladkorjem in ker naša slina nima dovolj močne obrambne sposobnosti. Za nastanek kariesa je potrebno več faktorjev.',
            preventivaTitle: 'Preventiva',
            preventivaP:
                'V ustih imamo veliko bakterij, ki jih uspešno odstranjujemo z rednim in natančnim <b>ščetkanjem</b> ter z doslednim <b>čiščenjem medzobnih prostorov</b> z zobno nitko ali medzobnimi ščetkami. Trudimo se, da <b>omejimo vnos sladkorja</b> in da zmanjšamo pogostnost vnosa sladkorja. Za vnos sladkorja šteje tudi sladkana kavica, sok ali voda z okusom, še posebej veliko sladkorja pa imajo sladkarije, ki že pregovorno uničujejo zobe.',
            zascitaTitle: 'Zaščita',
            zascitaP:
                '<b>Za zaščito pred kariesom je pomembna tudi naša slina</b>, saj deluje tako, da spira zobe, odstranjuje sladkorje, uničuje bakterije in krepi zobe z minerali, ki so naravno prisotni v njej. Za zadostno količino sline je zelo pomembno uživanje zadostnih količin vode. Minerale v slini lahko nadomeščamo z namenskimi pripravki (premazi), ki so na voljo tudi v naši ambulanti. Največkrat priporočamo GC MI paste plus.',
            zdravljenjeTitle: 'Zdravljenje',
            zdravljenjeP1:
                '<b>Kariesa v resnici zobozdravnik ne ozdravi</b>. Zalivke (plombice) so nadomestek zoba, s katerim omogočamo, da karies na tem mestu ne napreduje in da zob ohrani svojo obliko in funkcijo. <b>Najboljša zalivka je tista, ki je ni.</b> Vseeno se trudimo, da je ta nadomestek čimbolj podoben naravnemu zobu, da končna zalivka izgleda kot zdrav zob, ima podobne mehanske in fizikalne lastnosti. <b>Uporabljamo sodobne kompozitne materiale</b>, ki so varni, zanesljivi, preizkušeni in med najbolj kvalitetnimi.',
            zdravljenjeP2:
                'Občasno zaradi pogojev v ustih ali posebnih zahtev uporabimo steklasto ionomerne zalivke, ki imajo to prednost, da zaustavljajo karies in se izjemno močno nalepijo na zob.',
            zdravljenjeP3_1: 'V naši ambulanti dajemo velik poudarek higieni, ozaveščanju in ',
            zdravljenjeP3_2: 'preventivi',
            zdravljenjeP3_3:
                ', saj verjamemo, da je pravo zdravje odsotnost bolezni in to pomeni tudi odsotnost kariesa.',
            cenikPre: 'Cene pregledov in zalivk lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        ortopan: {
            title: 'Ortopan',
            infoPanelBold: 'Ortopan tomogram',
            infoPanelBody:
                'je osnovni diagnostični rentgen, ki omogoča pregled zobovja, kosti, obzobnih tkiv, sinusov, nosne votline in okoliških struktur.',
            intro: 'Ortopan posnamemo v posebni sobi, izolirani s svincem, da zaščitimo ljudi v okolici. Ortopan namreč seva rentgenske žarke, ki omogočajo pogled skozi tkiva.',
            potekTitle: 'Potek preiskave',
            potekP1:
                'Preiskava poteka tako, da zagrizete v posebno vodilo, brado naslonite na poličko, z rokami primete za ročaje in noge pomaknete blago naprej. Med snemanjem, ki traja 12 sekund, ste čisto mirni in se ne premikate, na ta način dobimo jasno sliko. Naš sodoben aparat odda minimalno količino sevanja, približno',
            potekRadiation:
                '7 mikroSV, to je 22x manj, kot ga dobite, če eno leto kadite škatlico in pol cigaret vsak dan.',
            priporocilTitle: 'Priporočilo',
            priporocilP1: 'Pregled z ortopanom je',
            priporocilSafe: 'varen in ga priporočamo vsaki dve leti za odrasle in otroke,',
            priporocilP2:
                'starejše od 8 let. Posnetek pošljemo po e-pošti vam in vašemu zobozdravniku. Po želji prenesemo posnetek na USB ključek.',
            cenikPre: 'Cene rentgenskih posnetkov lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        beljenje: {
            title: 'Beljenje zob',
            intro: 'V naši ambulanti opravljamo <b>tri vrste beljenja</b>. Za vse tri uporabljamo preverjene, varne in preizkušene proizvode Ameriškega proizvajalca Ultradent. Pri beljenju zobem vrnemo svežino in mladosten izgled, nikakor pa ne dosežemo beline WC školjke, kot si nekateri predstavljajo.',
            clinicalP: 'Primeri iz naše ordinacijske prakse:',
            beforeLabel: 'Pred terapijo',
            afterLabel: 'Po terapiji',
            inOfficeTitle: 'Beljenje v ordinaciji',
            inOfficeP1:
                '<b>Beljenje v ordinaciji</b> je najhitrejše, saj v uri in pol dosežemo opazen rezultat. Pred beljenjem počistimo mehke in trde zobne obloge, nato pa v usta vstavimo posebej nežen in udoben razpiralec ustnic, ki zaščiti mehka tkiva. Dlesni premažemo z gelom turkizne barve, na zobe pa nanesemo rdeč belilni gel za dvakrat po 20 minut. Po izteku časa gel izperemo, odstranimo zaščito in Vi žarite z novim, osveženim nasmehom.',
            inOfficeWarning:
                '<b>OPOZORILO</b>: Beljenje ne vpliva na barvo prevlek in zalivk in je primerno za paciente, ki imajo zdrave dlesni ter relativno malo nadomestkov na zobeh.',
            customTrayTitle: 'Beljenje z individualno opornico',
            customTrayP:
                '<b>Beljenje z individualno opornico</b> poteka v dveh obiskih, med prvim počistimo zobe mehkih in trdih oblog ter vzamemo odtis. Zobna tehnica po modelu Vaših zob izdela individualno belilno opornico, ki jo z belilnimi brizgami in navodili prevzamete na drugem obisku. Beljenje poteka doma, 8-10 ur. Spet velja, da lahko uporabite vse brizge zaporedoma, ali pa del uporabite kasneje.',
            takehomeTitle: 'Beljenje doma s konfekcijskimi opornicami',
            takehomeP:
                '<b>Beljenje s konfekcijskimi opornicami doma</b> poteka uro in pol. V paketu beljenja je vključen obisk, pri katerem odstranimo zobni kamen, spoliramo zobe in za domov dobite deset kompletov opornic (za zgornjo in spodnjo čeljust). Po želji lahko uporabite vseh deset opornic v zaporednih dneh, ali pa jih porabite le 5, ostale pa si spravite za kasneje.',
            cenikPre: 'Ceno storitev beljenja si lahko ogledate v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        parodontologija: {
            title: 'Parodontologija',
            intro1: 'Zdravje dlesni, ust in zob je neposredno povezano z zdravjem celega telesa.',
            introWarning: 'Krvavitev iz dlesni ob umivanju ali nitkanju, je znak za alarm.',
            intro2body: 'Krvavitev v ustih ni nikdar normalna in je ne smete jemati zlahka.',
            napredovanaTitle: 'Napredovana parodontalna bolezen',
            napredovanaP1:
                'Ali veste, da pri napredovani parodontalni bolezni skupna površina obzobnih žepov dosega velikost dlani?',
            napredovanaP2Bold:
                'Predstavljajte si, da bi imeli nekje na telesu zagnojeno rano v velikosti dlani',
            napredovanaP2body:
                'Verjetno bi hitro poiskali pomoč. Ta okužena rana v ustih pa ne boli, ni vidna in jo pogosto zanemarimo. Čeprav je daleč od oči, pa ni daleč od srca.',
            napredovanaP3:
                'Bakterije iz globokih parodontalnih žepov potujejo po vsem telesu in sprožajo stalno vnetje.',
            listTitle: 'Bakterije iz parodontalnih žepov sprožajo vnetje po vsem telesu:',
            listItem1: 'vpliva na poslabšanje sladkorne bolezni',
            listItem2: 'povečuje možnost pljučnih bolezni in okužb dihal',
            listItem3: 'slabša aterosklerozo',
            listItem4: 'vpliva na prezgodnji porod nosečnic in nizko porodno težo novorojenčkov',
            listItem5:
                'Bakterijske toksine iz parodontalne rane so našli celo v plakih pri Alzheimerjevi bolezni',
            kajLahkoTitle: 'Kaj lahko storimo?',
            kajLahkoPre:
                'Zato je pomembno, da redno spremljamo, ali so dlesni zdrave. To naredimo z merjenjem obzobnih žepkov s posebno sondo z zaobljeno konico, s pregledom krvavitev dlesni in oceno umika kostnine z ',
            kajLahkoXray: 'rentgenskim slikanjem',
            kajLahkoPost: '.',
            potekTitle: 'Potek zdravljenja',
            potekP1:
                'Za zdravljenje parodontalne bolezni uporabljamo ultrazvočni čistilec z namenskimi konicami, ki si si hkrati učinkovite in nežne.',
            potekP2pre: 'Natančno odstranitev oblog nad in pod dlesnijo dosežemo še z ',
            potekManual: 'ročnimi luščilci korenin',
            potekP2post: '.',
            laserTitle: 'Lasersko zdravljenje',
            laserP1pre: 'Poseben poudarek dajemo ',
            laserText: 'laserskemu zdravljenju',
            laserP1body:
                ', ki s preverjenim protokolom zdravljenja poskrbi za še bolj temeljito razkuževanje obzobnih žepov in odlično regeneracijo tkiva. Terapija poteka v lokalni anestezji, traja približno eno uro, ni boleča, okrevanje je hitro. Naenkrat oskrbimo polovico ust, čez 2-3 tedne pa še drugo polovico ust. Pacienti po posegu ne navajajo bolečin in lahko že naslednji dan jedo običajno hrano.',
            laserP2:
                'Za podporo pri zdravljenju Vam ponujamo ustne vode in namenska zdravila ter vse potrebne pripomočke (specialne zobne krtačke, medzobne ščetke).',
            cenikPre: 'Cene parodontoloških in laserskih storitev lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        otrosko: {
            title: 'Otroško zobozdravstvo',
            gradimoCeTitle: 'Gradimo zaupanje',
            gradimoP1:
                'Otroško zobozdravstvo predstavlja naši ambulanti pomembno poslanstvo. Otroku želimo na njemu prilagojen, vključujoč in obziren način predstaviti <b>obisk zobozdravnika kot prijetno doživetje</b>, ki pomaga k njegovemu zdravju in dolgoročno zdravemu odnosu do skrbi za zobe. Za otroke si vzamemo več časa in se prilagodimo razvojni stopnji in odzivu otroka. ',
            gradimoP2:
                'Naše pravilo je, da posegov <b>ne delamo na silo</b> in otroku najprej postopke razložimo, pokažemo in šele po dovoljenju izvedemo. Tak pristop včasih potrebuje več obiskov, ampak dolgoročno je uspešnejši, saj z otrokom <b>zgradimo odnos zaupanja in spoštovanja.</b>.',
            ortodontTitle: 'Ortodontsko zdravljenje',
            ortodontP:
                'Pri vsakem pregledu smo pozorni na čistočo zob, pogovarjamo se o higieni, prehrani in pijačah, pregledamo morebitna odstopanja v razvoju in opozorimo, če bi bilo potrebno ortodontsko zdravljenje. Posebej pozorni smo na <b>funkcionalne nepravilnosti</b>, to je npr. dihanje na usta, drža odprtih ust, napačno požiranje, sesanje palca ali predolga uporaba dude. Te navade pomembno vplivajo na razvoj čeljusti in jih v zgodnji fazi dokaj enostavno odpravimo s sistemom ',
            cenikPre: 'Cene posegov in pregledov lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        myobrace: {
            title: 'Myobrace',
            infoPanelBold: 'Myobrace',
            infoPanelBody: 'je terapija, ki odpravlja vzroke ortodontske nepravilnosti.',
            intro: 'Z uporabo aparata Myobrace in z vajami lahko pri otrocih v zgodnji starosti popravimo:',
            wrongList: [
                'Dihanje na usta',
                'Napačno požiranje',
                'Napačen položaj jezika',
                'Predolgo uporabo dude',
                'Predolgo sesanje prsta',
            ],
            correctTitleBold: 'Med terapijo z Myobrace otroku priučimo pravilne navade',
            correctList: ['Jezik na nebu', 'Pravilno požiranje brez uhajanja jezika', 'Dihanje na nos'],
            resultTitleBold: 'Ko odpravimo napačne navade, se čeljusti začnejo bolj pravilno razvijati',
            resultTitleSuffix: 'in s tem poskrbimo za',
            resultList: [
                'Pravilnejši razvoj obraza',
                'Manj možnosti za težave z dihanjem in dihali',
                'Manj kariesa',
                'Poravnani zobje',
            ],
            clinicalTitle: 'Klinični primeri',
            clinicalP: 'Primeri iz naše ordinacijske prakse:',
            beforeTherapy: 'Pred terapijo',
            afterTherapy: 'Po terapiji',
            whenTitle: 'Kdaj začeti?',
            whenP1: 'V primerjavi s klasično ortodontijo, je Myobrace zanimiv z vidika, da ',
            whenP2: '<b>odpravlja vzroke ortodontske nepravilnosti in ne samo posledice.</b> Posebej učinkovit je, če začnemo dovolj zgodaj. Po izkušnjah se nam je za idealno izkazala <b>starost okoli 7 do 8 let</b>. V tem obdobju so otroci dovolj zreli, da nosijo aparat zadosti časa in razumejo vaje, hkrati pa imajo pred sabo še nekaj let razvoja.',
            therapyTitle: 'Potek terapije',
            therapyP1pre: 'Terapija poteka v',
            therapySixVisits: 'šestih obiskih',
            therapyP2:
                'Na prvem obisku z miofunkcionalnim vprašalnikom ocenimo, katere nepravilnosti so prisotne in kaj se kaže na razvoju, poslikamo tudi fotografije začetnega stanja.',
            therapyP3:
                'Sledi 5 mesečnih kontrol, na katerih preverjamo napredek in sodelovanje, otrok pa vsak mesec dobi novo miofunkcionalno vajo.',
            therapyP4:
                'Po koncu prvega sklopa terapije ponovno poslikamo stanje zob in napravimo kolaž stanja prej-potem. Če opazimo napredek in spremembe na zobeh, se odločimo za drugo stopnjo terapije, kjer je glavni cilj, da širimo zgornjo čeljust.',
            therapyP5: 'Spet sledi 6 kontrol in končna ocena.',
            therapyResults:
                'Terapija pri otrocih <b>že po 6 mesecih kaže rezultate</b>, ki jih opazijo tudi starši.',
            cenikPre: 'Ceno aparata Myobrace lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        invisalign: {
            title: 'Invisalign',
            intro1: '<b>Invisalign je najbolj izpopolnjen in najuglednejši sistem za poravnavo zob na svetu</b>, zaupa mu že preko 16 milijonov ljudi. <b>Gre za prozorne aparate, ki so med nošenjem skoraj nevidni</b>, odpravljajo tesno stanje ali razmake med zobmi.',
            intro2: 'Za izdelavo aparata uporabljamo najmodernejši digitalen odtis zob (skeniranje), torej nobenih odtisnih žlic ali siljenja na bruhanje. Po skeniranju zob vam pokažemo simulacijo novega nasmeha, temu sledi natančen načrt zdravljenja in določitev trajanja terapije. Načrt potrdimo skupaj in s 3D tiskalniki natisnejo vaš komplet poravnalcev zob.',
            benefit1Bold:
                'Zdravljenje je hitro, neboleče, ne ovira vas pri vsakodnevnih opravilih, med hranjenjem pa aparat enostavno snamete iz zob.',
            benefit2:
                'Za določeno število tednov dobite ustrezno število opornic, ki so prilagojene točno vam, vsaka pa ima čisto svojo nalogo. Aparat je potrebno nositi večino dneva, 20-22 ur na dan, snamete ga lahko le med hranjenjem in umivanjem zob.',
            clinicalTitle: 'Klinični primeri',
            clinicalP: 'Primeri iz naše ordinacijske prakse:',
            beforeTherapy: 'Pred terapijo',
            afterTherapy: 'Po terapiji',
            goldTitlePre: 'Nosilec oznake',
            goldTitleBold: 'Gold Invisalign Provider',
            goldP1pre:
                'Sočutno zobozdravstvo je, kot eno izmed redkih v Sloveniji, leta 2023 postalo nosilec častne zlate plakete podjetja Invisalign',
            goldP1Bold: 'GOLD Invisalign provider',
            goldP2: 'Plaketo smo prejeli v rekordnem letu dni delovanja!',
            goldP3: 'Kriteriji pri podeljevanju so strokovnost, izkušenost in število uspešno opravljenih primerov.',
            priceTitlePre: 'Invisalign cena -',
            priceTitleBold: 'Koliko stane nevidni zobni aparat Invisalign',
            pricePre:
                'Ponujamo pakete od 7 do 20 tednov, odvisno od težavnosti in želja posameznikov. <br />Cena Invisalign aparata je odvisna od števila opornic. Več v',
            priceCenikPre: ' ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        lasersko: {
            title: 'Lasersko zobozdravstvo',
            p1: 'Laser odlično odstranjuje bakterije v <b>kanalih zoba</b>, kar je posebej pomembno pri dolgotrajnih okužbah kanalov (gangrena). Po razkuževanju kanala z laserjem imamo več možnosti, da je zob uspešno pozdravljen in bo dlje časa ostal v ustih.',
            kirurgijaTitle: 'Kirurgija',
            kirurgijaP:
                'Z laserjem <b>skoraj neboleče</b> režemo ali <b>preoblikujemo dlesen</b> ali tkiva v ustih. Po posegu z laserjem klasično kirurško šivanje ni potrebno, saj ima tkivo "zaprte" robove in tudi krvavitve ni.',
            kirurgijaReshape: 'preoblikujemo dlesen',
            beljenjeTitle: 'Beljenje zob',
            beljenjeP:
                'Pri <b>beljenju</b> zob aktiviramo gel z laserjem, kar skrajša čas beljenja in poveča učinkovitost beljenja.',
            parodontTitle: 'Zdravljenje parodontalne bolezni',
            parodontP:
                'V zobni ambulanti uporabljamo laser za učinkovito zdravljenje in kot pripomoček pri številnih težavah. Najbolj se izkaže pri zdravljenju <b>parodontalne bolezni</b>. Poleg soničnega in ročnega čiščenja žepov, pri zdravljenju uporabljamo najnovejša dognanja ter žepe razkužimo še z laserjem. V žepe po čiščenju dodamo tekočino, ki se speni in dodatno razkuži kanale. S tem temeljito počistimo parodontalne žepe in jih razkužimo tudi na mestih, kjer s konico instrumentov nismo dovolj temeljiti. <b>Dolgoročno je kombinirano zdravljenje z laserjem veliko bolj uspešno, kot zdravljenje samo z mehanskimi metodami.</b>',
            cenikTitleBold: 'Lasersko zobozdravstvo - cena',
            cenikPre: 'Cene laserskih posegov lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        frenulotomija: {
            title: 'Laserska frenulotomija',
            infoPanelBold: 'Frenulotomija',
            infoPanelBody: 'je poseg, pri katerem skrajšamo prekratke vezi v ustih.',
            vezListTitle: 'Vezi v ustih je več:',
            vezList: ['podjezična vez', 'vez zgornje ustnice', 'vez spodnje ustnice', 'lične vezi'],
            podjezicnaTitle: 'Prekratka podjezična vez',
            podjezicnaP1:
                '<b>Največ težav povzroča podjezična vez,</b> ki omejuje gibanje jezika. Zaradi tega lahko opazimo težave že pri dojenčkih, ali pa šele kasneje v razvoju.',
            podjezicnaP2Bold: 'Prekratka podjezična vez lahko vodi v vrsto težav.',
            dojenckiListTitle: 'Težave pri dojenčkih:',
            dojenckiList: [
                'težave z dojenjem in pridobivanjem teže',
                'slab sesalni refleks',
                'zajame premalo dojke in s tem povzroča mami hude bolečine in razjede na bradavici',
            ],
            otrokListTitle: 'Težave pri otrocih:',
            otrokList: [
                'težave pri govoru: predvsem s črkami R in L',
                'težave pri prehranjevanju: otroci jedo počasi, hrano si "tlačijo" v lica, so izbirčni, ne prenašajo trde hrane, se med hranjenjem ustavljajo in si pomagajo s prsti, pogosto se jim hrana zatakne ali jim hrana zahaja v sapnik.',
            ],
            podjezicnaP3:
                'Če ob pregledu ugotovimo, da ima otrok prekratko podjezično vez, hkrati pa ima vsaj nekaj od naštetih težav, je smiseln <b>prerez vezi.</b>',
            podjezicnaP4:
                '<b>Tudi pri predšolskih in šolskih otrocih</b> je prerez smiseln, če opazimo kratko podjezično vez in vsaj nekaj od naštetih simptomov.',
            zgornjaTitel: 'Kratka vez zgornje ustnice',
            zgornjaiP:
                'Kratka vez zgornje ustnice lahko povzroča težave zaradi omejene gibljivosti zgornje ustnice:',
            zgornjaListTitle: 'Težave zaradi prekratke vezi zgornje ustnice:',
            zgornjaList: ['zastajanje hrane pod ustnico', 'slabo čiščenju zob', 'razmak med zobmi'],
            potekTitle: 'Potek posega',
            potekP1:
                'Pred vsakim posegom se s starši temeljito pogovorimo o težavah, ki so jih opazili, otroka skrbno pregledamo, dobite pa tudi navodila o negi ter vajah po posegu.',
            potekP2Bold: 'Pri nas poseg opravimo z laserjem.',
            potekP2body:
                'Gre za varen, hiter in skoraj neboleč postopek. Starši so med posegom prisotni in dojenček se takoj po posegu lahko potolaži pri mamici in nahrani.',
            cenikTitlePre: 'Frenulotomija cena -',
            cenikTitleBold: 'Koliko stane frenulotomija jezika',
            cenikPre: 'Cene frenulotomije v naši ordinaciji lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        protetika: {
            title: 'Prevleke in mostički',
            mosticekTitle: 'Mostiček',
            mosticekP1:
                'Ko v ustih manjka zob, ga je potrebno nadomestiti. S tem povrnemo možnost uspešnega grizenja, žvečenja, ravnovesja mišic in žvečnih sklepov ter estetiko.',
            mosticekInfoBold: 'Mostiček',
            mosticekInfoBody:
                'je fiksen protetični izdelek, ki ga zacementiramo na sosednje zobe in se ne snema.',
            mosticekP2pre: 'Z mostičkom nadomestimo krajše vrzeli. Po pravilu obrusimo dva zoba, da ',
            mosticekReplace: 'nadomestimo en ali dva manjkajoča zoba',
            mosticekP2post: '. Nosilna zoba sta "oporna stebra", ki nosita manjkajoči zob - "mostiček".',
            prevlekeTitle: 'Prevleke - krone',
            prevlekeP1pre: 'Po ',
            prevlekeEndo: 'endodontskem zdravljenju',
            prevlekeP1post:
                ', pri zelo oslabljenih, poškodovanih, zabarvanih ali uničenih zobeh se odločimo za prevleko ali krono.',
            prevlekeP2pre: 'Na izbiro imamo ',
            prevlekeMetalCeramic: 'kovinsko keramiko',
            prevlekeP2mid1: ', ',
            prevlekeFullCeramic: 'polno keramiko',
            prevlekeP2mid2: ' ali ',
            prevlekeZirconia: 'cirkon',
            prevlekeP2post:
                '. Pri tem naredimo prostor in obrusimo zob v primerno obliko, da nanj zobni tehnik oblikuje nov, lepši in bolj funkcionalen nadomestek.',
            luskeTitle: 'Zobne luske',
            luskeInfoBold: 'Zobne luske',
            luskeInfoBody:
                'so tanke ploščice na sprednji strani zob, s katerimi delno spreminjamo barvo, obliko ali nagib zoba.',
            luskeP1: 'Pri tem je potrebno le minimalno brušenje zoba, včasih pa se mu lahko celo izognemo.',
            luskeP2pre: 'Luske delamo iz ',
            luskeZirconia: 'cirkona',
            luskeP2post: ' in zelo polepšajo izgled zob.',
            luskeP3: 'Primerne so za pretežno zdrave zobe, brez velikih zabarvanj ali zalivk.',
            materialiTitle: 'Materiali',
            materialiIntro: 'Na izbiro imamo več materialov za oskrbo vrzeli.',
            materialiMetalCeramicBold: 'Kovinska keramika',
            materialiMetalCeramicBody:
                'je primerna za zobe v zadnjem predelu ust, ki prenašajo velike žvečne sile. Žilavost kovine je združena z estetiko keramike, ki je prevlečena po celotnem protetičnem delu, zato kovina navzven ni nikjer vidna.',
            materialiFullCeramicBold: 'Polna keramika',
            materialiFullCeramicBody:
                'se uporablja na sprednjih zobeh, kjer si želimo predvsem lep izgled in veliko trdnost, ki nam jo keramika ponuja.',
            materialiZirconiaBold: 'Cirkon',
            materialiZirconiaBody:
                'je novejši material s še trdnejšo strukturo, ki je v zadnjem času pri nas izjemno popularen za nadomeščanje sprednjih zob, saj najbolj posnema izgled naravnih zob.',
            cenikPre: 'Cene posameznih protetičnih rešitev si lahko ogledate v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        injekcijskaTehnika: {
            title: 'Injekcijska tehnika',
            introP1: 'Nenavadno ime za postopek, ki lahko popolnoma spremeni vaš nasmeh.',
            introP2:
                'Pri injekcijski tehniki na vaše zobe brez brušenja nanesemo sloj kompozitnega materiala, s katerim jim spremenimo obliko, velikost ali delno tudi barvo. Gre za specializiran tekoč kompozit (material za izdelavo zalivk) japonskega proizvajalca GC.',
            infoBold: 'Injekcijska tehnika',
            infoBody:
                'je bonding s tekočim kompozitom, ki ga nanesemo brez brušenja zob prek prozorne šablone (silikonskega ključa).',
            introP3: 'Za izdelavo so potrebni trije obiski.',
            potekTitle: 'Potek izdelave',
            obisk1Title: '1. obisk – skeniranje in načrtovanje',
            obisk1P:
                'V prvem obisku vam poskeniramo zobe – naredimo digitalni odtis in poslikamo obraz. Zobotehnica nato oblikuje vaš nov nasmeh, natisne model vaših novih zob s 3D tiskalnikom in pripravi prozorno šablono.',
            obisk2Title: '2. obisk – nanašanje kompozita',
            obisk2P1:
                'V drugem obisku vam zobe pripravimo na nanašanje materiala, zaščitimo sosednje zobe, nanesemo adheziv (lepilo) in v šablono vbrizgamo kompozitno maso. Zaradi uporabe brizge s tekočim kompozitom je tehnika tudi dobila takšno ime.',
            obisk2P2:
                'Z modro polimerizacijsko lučko presvetlimo zob skozi prozorno šablono, material se strdi in prilepi na zobe. Sledi odstranjevanje viškov, poliranje in končna obdelava, po kateri zobje izgledajo naravno svetleči in podobni sosednjim.',
            obisk3Title: '3. obisk – kontrolni pregled',
            obisk3P:
                'Čez en mesec opravimo kontrolni pregled. Takrat popravimo drobne nepravilnosti, npr. če so kje ostale hrapave površine. Ocenimo ugriz in se pogovorimo glede vaših izkušenj v preteklem mesecu. Opravimo tudi končno fotografiranje.',
            clinicalTitle: 'Klinični primer',
            clinicalP: 'Primer iz naše ordinacijske prakse:',
            beforeTherapy: 'Pred posegom',
            afterTherapy: 'Po posegu',
            prednostiTitle: 'Prednosti injekcijske tehnike',
            prednostiList: [
                'ne posegamo v zobe, jih ne brusimo in ne odnašamo zobne substance',
                'postopek je razmeroma hiter',
                'postopek je povsem neboleč',
                'rezultat je hiter in estetski',
                'ker zobe oblikuje zobotehnica v laboratoriju, so vsi zobje idealne oblike in imajo pravilne kontakte s sosednjimi zobmi, kar dolgoročno omogoča uspešno čiščenje zob in zdravo dlesen; tehnika predvidi tudi ugriz, zato je dograditev dolgoročno uspešna in se ne kruši',
                'pred začetkom postopka lahko vidite končni rezultat',
                'popravki so enostavni, ker ohranimo vašo šablono in jo po potrebi ponovno uporabimo',
                'izgled je naraven',
            ],
            primernaTitle: 'Kdaj je injekcijska tehnika primerna',
            primernaList: [
                'ko želimo spremeniti obliko in velikost zob',
                'za zapiranje diastem (manjših razmakov) med zobmi',
                'za dograditev obrabljenih ali poškodovanih zob',
                'za uskladitev dolžine ali velikosti sprednjih zob (npr. zgornji stranski sekalci, ki so enostransko ali obojestransko premajhni)',
            ],
            cenikPre: 'Ceno injekcijske tehnike lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        endodontsko: {
            title: 'Endodontsko zdravljenje',
            introPre:
                'Ste že slišali za granulom ali mrtev zob? Ste kdaj že doživeli izjemno močno bolečino v zobu, ki vam ni dala spati? Ne sliši se nič kaj prijetno, kajne? V vseh teh primerih je zdravljenje podobno, imenujemo ga ',
            introBold: 'endodonsko zdravljenje zob',
            introPost: 'ali koreninsko zdravljenje.',
            potekTitle: 'Potek zdravljenja',
            potekP1:
                'Pri tem zdravljenju odstranimo odmrle celice, ostanke žil in živcev ter bakterije in kanalov, ki so v vsaki korenini zoba. Odstranjevanje je mehansko, z ročnimi in modernimi ter zanesljivimi strojnimi iglami in pilami, ter kemično, z varnimi, a učinkovitimi raztopinami.',
            potekP2pre: 'Pri endodntskem zdravljenju je največji izziv dobra preglednost, kar dosežemo z ',
            potekP2Bold: 'uporabo povečevalnih lup z močno osvetlitvijo',
            potekP2post: '.',
            potekP3Bold: 'Po prvem čiščenju kanalov damo v zob "zdravilo"',
            potekP3body:
                ', to je specialna pasta z visokim pH (močna baza), ki dodatno razkuži kanale in omogoči telesu, da premaga bakterijsko okužbo. Zob začasno zapremo in vas naročimo v roku približno 3 tednov.',
            potekP4pre:
                'Če času teh 3 tednov niste imeli težav, če zob ni občutljiv in ni več vonja, ga lahko dokončno napolnimo. ',
            potekP4Bold: 'Tak zob lahko v ustih služi še dolga leta',
            potekP4post:
                ', nanj edino ne boste čutili vročine ali mrzlega, pa tudi bolečine ne. Če je krona dobro ohranjena, uspešnost zdravljenja preverimo z rentgenskim posnetkom in nato napravimo dokončno zalivko.',
            potekP5Bold: 'Če manjka velik del zoba, ga ojačamo s prevleko',
            potekP5post:
                'ali endo krono, da zagotovimo dobro zaporo in trdnost, s tem pa tudi dolgoživost zoba.',
            cenikPre: 'Ceno endodontskega zdravljenja lahko preverite v ',
            cenikLinkText: 'ceniku',
            cenikPost: '.',
        },
        onas: {
            title: 'O nas',
            urska: {
                name: 'Urška Šavli',
                title: 'Doktorica dentalne medicine',
                poklicnoTitle: 'Poklicno',
                poklicnoP1: 'Zobozdravnica z več kot 10 let delovnih izkušenj na področju zobozdravstva.',
                poklicnoP2:
                    'Diplomirala je leta 2013 na Univerzi v Ljubljani in pridobila naziv doktorica dentalne medicine.',
                quote: 'Veseli jo delo z ljudmi, klepetanje s pacienti in ponosna je na vsakogar, ki v Sočutnem zobozdravstvu premaga strah.',
                poklicnoP3:
                    'Redno se izobražuje na zobozdravniških seminarjih doma in v tujini. Posebej se navdušuje nad miofunkcionalno terapijo, nevidnimi aparati in zanimajo jo podjezične vezi ter njihov vpliv na razvoj obraza.',
                osebnoTitle: 'Osebno',
                osebnoP1:
                    'Je žena, mati treh šolskih otrok, dveh fantov in dekleta, po poreklu Ljubljančanka, po duši Belokranjka.',
                osebnoP2:
                    'V prostem času rada bere leposlovje in strokovno literaturo s področja naravoslovja, zanima pa jo tudi umetnostna zgodovina.',
                osebnoP3: 'Ima popolnoma zdrave zobe, brez ene plombe.',
                zanimivostiTitle: '3 zanimivosti',
                zanimivosti1:
                    'Urška ne mara majhnih lego kock in nima nobene dobre ideje, kaj sestaviti iz njih.',
                zanimivosti2: 'Obožuje potovanja, izlete in dopuste z otroki. Najljubše: London junija 2025.',
                zanimivosti3: 'Nikdar v življenju ni naredila stoje na glavi.',
            },
            katja: {
                name: 'Katja Cerar',
                title: 'Diplomirana medicinska sestra',
                poklicnoTitle: 'Poklicno',
                poklicnoP1:
                    'Diplomirana medicinska sestra Katja je prvi glas, ki ga slišite, ko nas pokličete. S potrpežljivostjo, prijaznostjo in ustrežljivostjo očara vsakogar.',
                poklicnoP2: 'Diplomirala je z odliko leta 2016 na Univerzi v Ljubljani.',
                poklicnoP3:
                    'Ima narejen certifikat iTop advanced in obvlada teorijo in prakso ustne higiene.',
                poklicnoP4:
                    'V ambulanti skrbi, da delo poteka gladko, da so vsi pripomočki na svojem mestu in da je vse sterilno, urejeno ter pregledno.',
                poklicnoP5:
                    'Prijazno odgovarja na maile in klice, naroča na termine in odgovori na vsa vprašanja.',
                quote: 'Med delom preverja, ali se pacient dobro počuti, če ima dvome ali skrbi in ga spodbuja. Pozna najboljše trike, da vam med posegi voda ne teče v grlo. Dobesedno!',
                osebnoTitle: 'Osebno',
                osebnoP1: 'Je partnerka, mamica dveh otrok, ene šolske deklice in vrtčevskega fantka.',
                osebnoP2:
                    'V prostem času veliko pozornosti nameni gibanju v naravi in druženju z otroki. Uživajo tudi v ogledu predstav in obiskovanju knjižnice.',
                osebnoP3:
                    'Mladostna leta je preživela v Črnomlju, zdaj pa živi v bližini Metlike, kjer pozna vse kotičke ob Kolpi.',
                osebnoP4: 'Zelo rada speče kaj sladkega in okusnega.',
                osebnoP5: 'Tudi Katja v ustih nima niti ene plombe.',
                zanimivostiTitle: '3 zanimivosti',
                zanimivosti1: 'Katja ima rada samo zelene banane',
                zanimivosti2: 'Ne zna žvižgati',
                zanimivosti3Quote: '"Sočutno zobozdravstvo, izvolite?"',
                zanimivosti3: 'Včasih se na zaseben telefonski klic pomotoma javi: {quote}',
            },
            mediaTitle: 'Objave v medijih',
            media: {
                rtv1SvetovalniServis: 'RTV Slo - Svetovalni servis',
                rtv1Title: 'Kakšna je ustrezna skrb za ustno zdravje?',
                rtv1SvetovalniDescription:
                    'Osrednja kontaktna oddaja s strokovnjaki s področja zdravstva, prava, financ, ...',
                aktivniService: 'Podkast Aktivni',
                aktivniTitle: 'Dr. Urška Šavli: Ni zdravega telesa brez tega',
                aktivniDescription: 'Podkast o navdihujočih zgodbah aktivnih ljudi',
                sreckaService: 'Podkast Srečka',
                sreckaTitle: 'Zdravje zob ima večji vpliv na tvoje zdravje kot si predstavljaš',
                sreckaDescription: 'Podkast, ki raziskuje teme povezane z izboljšanjem kvalitete življenja',
                rtv2Title: 'Ustno zdravje',
                ogledaloService: 'Podkast Ogledalo',
                ogledaloTitle: 'Kaj imata skupnega duševno zdravje in zdravje zob?',
                ogledaloDescription: 'Podkast o psihologiji, miselni naravnanosti in osebni rasti',
                poslusamSeService: 'Podkast Poslušam se',
                poslusamSeTitle: 'Otroški zobje od A do Ž',
                poslusamSeDescription:
                    'Pogovori s strokovnjaki o razvoju otroka, vzgoji in pedagoških tematikah',
                rtvTitle3: 'Svetovni dan ustnega zdravja - Ustna higiena',
                vasKanalService: 'Vaš kanal',
                vasKanalTitle: 'Delavnica o ustnem zdravju za starejše',
                vasKanalDescription:
                    'Prispevek o delavnicah "Ustno zdravje" ZZZS za različne starostne skupine',
            },
        },
        cenik: {
            title: 'Cenik',
            back: 'Nazaj',
            validFrom: 'Cenik velja od 1.3.2026.',
            vatNote: 'DDV v skladu s 1. točko 94. člena ZDDV-1 ni zaračunan.',
            splosno: 'Splošno',
            splosnoPregled: 'Stomatološki pregled',
            splosnoPregledOtroci: 'Stomatološki pregled otroci',
            sploslnoPosvet: 'Posvet z zobozdravnico',
            splosnoPosvetnMin: '15 minut',
            sploslnoPredpisovanje: 'Predpisovanje zdravila',
            splosnoNapotnica: 'Pisanje napotnice ali izvida',
            splosnoOtrokNePusti: 'Otrok ne pusti posega',
            splosnoOtrokNePustiMin: 'vsakih 15 minut',
            splosnoManjsiPoseg: 'Manjši poseg',
            splosnoManjsiPosegMin: 'do 10 minut',
            splosnoSrednji: 'Srednji poseg',
            splosnoZahteven: 'Zahteven poseg',
            rentgen: 'Rentgen',
            rentgenOrtopan: 'Ortopan',
            preventiva: 'Preventiva',
            preventivaSonicno: 'Sonično odstranjevanje zobnega kamna + poliranje',
            preventivaPeskanje: 'Peskanje',
            preventivaPeskanjeNaC: 'po čeljusti',
            preventivaScetkaPoliranje: 'Ščetkanje in poliranje',
            preventivaScetkaPoliranjeNaC: 'po čeljusti',
            preventivaFluoridi: 'Topikalna aplikacija fluoridov',
            preventivaFisure: 'Zalitje fisur',
            preventivaFisureNaZ: 'po zobu',
            preventivaPouk: 'Pouk o ustni higieni, kontrola plaka z barvilom in navodila',
            preventivaSDF: 'premaz',
            preventivaSdfNaZ: 'en zob / več zob',
            preventivaGluma: 'Premaz proti preobčutljivosti Gluma',
            preventivaGlumaNaK: 'po kvadrantu',
            zobneBolezni: 'Zobne bolezni',
            zobneBolezniMajhnaZ: 'Majhna zalivka',
            zobneBolezniSrednjaZ: 'Srednja zalivka',
            zobneBolezniVelikaZ: 'Velika zalivka',
            zobneBolezniMlecniZ: 'Zalivka na mlečnih zobeh',
            zobneBolezniMlecniZTip: 'enostavna / večploskovna',
            zobneBolezniDograditev: 'Dograditev zoba - bonding',
            zobneBolezniInjekcijska: 'Injekcijska tehnika',
            zobneBolezniInjekcijskaOpis: 'bonding s tekočim kompozitom preko silikonskega ključa (na zob)',
            zobneBolezniBruksizem: 'Bruksistična opornica (Michiganska)',
            estetika: 'Estetsko zobozdravstvo',
            estetikaDomace: 'Domače beljenje',
            estetikaDomaceIndividualno: 'Domače beljenje z individualnimi opornicami',
            estetikaDomaceLasersko: 'Lasersko beljenje v ordinaciji',
            estetikaNots: 'Notranje beljenje zabarvanega zoba na sejo',
            estetikaIcon: 'ICON',
            estetikaIconOpis: 'na dveh / treh / več kot treh zobeh',
            esteitikaBisercek: 'Estetski biserček na zobu',
            endodontija: 'Koreninsko zdravljenje zob',
            endodontijaPolnitev: 'Polnitev koreninskega kanala',
            endodontijaPolnitevEnok: 'Polnitev enokoreninskega zoba',
            endodontijaOdstranjevanje: 'Odstranjevanje stare polnitve s strojnim širjenjem',
            endodontijaOdstranjevanjeNaK: 'na kanal',
            endodontijaMenjava: 'Menjava zdravila',
            endodontijaMenjavaPerK: 'po kanalu',
            endodontijaStrojno:
                'Strojno širjenje, irigacija kanala <small>na kanal</small>, uporaba apeks lokatorja',
            endodontijaKritje: 'Kritje pulpe direktno/indirektno',
            endodontijaKritjeDod: 'dodatek',
            endodontijaZacasna: 'Začasna zalivka',
            endodontijaTrepanacija: 'Trepanacija pulpnega kanala',
            endodontijaToksavit: 'Toksavit + cavit',
            lasersko: 'Lasersko zobozdravstvo',
            laserskoParodontalno: 'Parodontalno zdravljenje z laserjem',
            laserskoParodontalnoPolUst: 'polovica ust',
            laserskoFrenulotomija: 'Frenulotomija',
            laserskoFrenulotomijaOpis: 'pregled + poseg',
            laserskoFrenulotomijaSamo: 'Pregled za frenulotomijo',
            laserskoFrenulotomijaSamoOpis: 'pregled brez posega',
            laserskoManjsi: 'Manjši poseg z laserjem',
            laserskoBeljenje: 'Lasersko beljenje zob v ordinaciji',
            fiksnaProtetika: 'Fiksna protetika',
            fiksnaProtetikaKovinskoKer: 'Kovinsko keramična prevleka ali člen',
            fiksnaProtetikaKovinskoKerNaE: 'na enoto',
            fiksnaProtetikaPolnoPor: 'Polnoporcelanska ali cirkonska prevleka ali člen',
            fiksnaProtetikaPolnoPorNaE: 'na enoto',
            fiksnaProtetikaInlay: 'Inlay, onlay, endo krona - kompozitna',
            fiksnaProtetikaInlayKer: 'Inlay, onlay, endo krona - keramična',
            fiksnaProtetikaLuska: 'Cirkonska ali porcelanska estetska luska',
            fiksnaProtetikaFRC: 'FRC zatiček',
            fiksnaProtetikaZacasna: 'Začasna prevleka - PMMA',
            fiksnaProtetikaZacasnaNaZ: 'na zob',
            snemnaProtetika: 'Snemna protetika',
            snemnaProtetikaTotalna: 'Totalna proteza',
            snemnaProtetikaDelnaZac: 'Delna proteza - začasna',
            snemnaProtetikaDelnaVizil: 'Delna proteza - vizil',
            snemnaProtetikaPodlozitev: 'Podložitev ali reparatura proteze',
            snemnaProtetikaFolija: 'Začasna folija z zobom za nadomestitev manjkajočega zoba',
            kirurgija: 'Kirurgija',
            kirurgijaEkstrakcija: 'Ekstrakcija zoba',
            kirurgijaEkstrakcijaTip: 'enokoreninskega / večkoreninskega',
            kirurgijaKomplicirana: 'Komplicirana ekstrakcija zoba',
            kirurgijaAnestezija: 'Lokalna anestezija',
            kirurgijaMlecni: 'Enostavna ekstrakcija mlečnega zoba',
            kirurgijaMlecniTip: 'enokoreninskega / večkoreninskega',
            kirurgijaLaser: 'Poseg z laserjem',
            ortodontija: 'Ortodontija',
            ortodontijaMyobrace: 'opornica',
            ortodontijaMyobracePlus: '+ 5 mesečnih kontrol + spremljanje in vaje',
            ortodontijaMyobrace3: 'opornica 3. stopnja',
            ortodontijaMyobraceIzg: 'opornica',
            ortodontijaMyobraceIzgOpis: 'izgubljena ali uničena',
            ortodontijaLipTrainer: 'Lip trainer / MYOchew',
            ortodontijaFroggy: ' aparat + 3 pregledi',
            ortodontijaInvisalignFirst: 'First',
            ortodontijaInvisalignExpress: 'Express',
            ortodontijaInvisalignExpressNaC: 'ena čeljust / obe čeljusti',
            ortodontijaInvisalignLite: 'Lite',
            ortodontijaInvisalignLiteNaC: 'ena čeljust / obe čeljusti',
            ortodontijaInvisalignModerate: 'Moderate',
            ortodontijaInvisalignModerateNaC: 'ena čeljust / obe čeljusti',
            ortodontijaInvisalignComprehensive: 'Comprehensive',
            ortodontijaInvisalignComprehensiveNaC: '3 leta / 5 let',
            ortodontijaInvisalignVivera: 'Vivera retainers',
            parodontologija: 'Parodontologija',
            parodontologijaOpornica: 'Parodontalna opornica ojačana s steklasto-kompozitnimi vlakni',
            parodontologijaZdravljenje: 'Parodontalno zdravljenje (dva kvadranta) - ena stran',
            parodontologijaLaser: 'Lasersko zdravljenje parodontalne bolezni',
            parodontologijaLaserDod: 'dodatek',
            izdelki: 'Izdelki za ustno nego',
            izdelkiScetka: 'Zobna ščetka',
            izdelkiScetkaOpis: 'kids / baby / 5460 / solo',
            izdelkiPasta: 'Zobna pasta <b>Curasept sensitive</b> / perio gel',
            izdelkiScetka3pack: 'Komplet 3 zobnih ščetk <b>CS 5460 3pack</b>',
            izdelkiUstnaVoda: 'Ustna voda <b>Curasept</b>',
            izdelkiPastaKids: 'Zobna pasta <b>Curaprox kids</b>',
            izdelkiPastaKidsOpis: 'jagoda ali mentol',
            izdelkiFluorprotector: '<b>Fluorprotector</b> gel',
            izdelkiMI: 'GC MI paste plus / GC Tooth mousse',
        },
    },
    router: {
        home: 'Sočutno zobozdravsto',
        cenik: 'Sočutno zobozdravsto - Cenik',

        oNas: 'Sočutno zobozdravsto - O nas',
        oNasDescription:
            'Zobozdravstvena ambulanta v Črnomlju. Nudimo zdravstvene storitve za otroke in odrasle s sočutnim, mirnim in obzirnim pristopom in strokovno podkovanostjo. Storitve obsegajo nevidne ortodontske aparate Invisalign, ortodontske opornice Myobrace, parodontologijo, endodontijo, kirurgijo, estetiko, otroško zobozdravstvo, frenulotomijo, beljenje zob. Poudarek dajemo ortodontskemu zdravljenju z ortodontskimi aparati Invisalign in Myobrace.',

        pregledi: 'Sočutno zobozdravstvo - Pregledi',
        karies: 'Sočutno zobozdravstvo - Karies',
        ortopan: 'Sočutno zobozdravstvo - Ortopan',
        beljenje: 'Sočutno zobozdravstvo - Beljenje',
        parodontologija: 'Sočutno zobozdravstvo - Parodontologija',
        otrosko: 'Sočutno zobozdravstvo - Otrosko',
        myobrace: 'Sočutno zobozdravstvo - Myobrace',

        invisalignTitle:
            'Invisalign cena - Koliko stane nevidni zobni aparat Invisalign - Sočutno zobozdravstvo',
        invisalignDesc:
            'Cena Invisalign aparata je odvisna od števila opornic in stanja vaših zob. Preverite ceno Invisalign aparata. Smo med vodilnimi ponudniki Invisalign aparatov na Dolenjskem.',

        laserTitle:
            'Lasersko zobozdravstvo - Zdravljenje parodontoze, Kirurgija, Preoblikovanje tkiv in dlesni, Beljenje - Sočutno zobozdravstvo',
        laserDesc:
            'Laser odlično odstranjuje bakterije, kar je posebej pomembno pri dolgotrajnih okužbah kanalov (gangrena). Po razkuževanju kanala z laserjem imamo več možnosti, da je zob uspešno pozdravljen in bo dlje časa ostal v ustih. Z laserjem skoraj neboleče režemo ali preoblikujemo dlesen ali tkiva v ustih. Po posegu z laserjem klasično kirurško šivanje ni potrebno, saj ima tkivo "zaprte" robove in tudi krvavitve ni. Najbolj se izkaže pri zdravljenju parodontalne bolezni. Poleg soničnega in ročnega čiščenja žepov, pri zdravljenju uporabljamo najnovejša dognanja ter žepe razkužimo še z laserjem. V žepe po čiščenju dodamo tekočino, ki se speni in dodatno razkuži kanale. S tem temeljito počistimo parodontalne žepe in jih razkužimo tudi na mestih, kjer s konico instrumentov nismo dovolj temeljiti. Dolgoročno je kombinirano zdravljenje z laserjem veliko bolj uspešno, kot zdravljenje samo z mehanskimi metodami.',

        frenulotomijaTitle: 'Laserska frenulotomija jezika - Prerez podjezične vezi - Sočutno zobozdravstvo',
        frenulotomijaDesc:
            'Nudimo posege laserske frenulotomije (tudi frenulotomija jezika). Frenulotomija je poseg, pri katerem skrajšamo prekratke vezi v ustih: podjezično vez, vez zgornje ali spodnje ustnice, lične vezi. Poseg opravimo z laserjem. Gre za varen, hiter in skoraj neboleč postopek.',

        protetikaTitle:
            'Sočutno zobozdravstvo - Zobna protetika. Mostički, prevleke (krone), luske - Prerez podjezične vezi',
        protetikaDesc:
            'Moderna vrhunska zobna protetika brez čakalnih vrst. Izdelava kovinsko-keramičnih polno-keramičnih in cirkonskih mostičkov, prevlek (kron) in lusk.',

        endodontsko: 'Sočutno zobozdravstvo - Endodontsko',

        injekcijskaTehnikaTitle:
            'Injekcijska tehnika - Bonding s tekočim kompozitom brez brušenja zob - Sočutno zobozdravstvo',
        injekcijskaTehnikaDesc:
            'Injekcijska tehnika je postopek spreminjanja oblike, velikosti in barve zob s tekočim kompozitnim materialom GC, nanesenim brez brušenja. Primerna za zapiranje razmikov med zobmi, dograditev obrabljenih zob in izboljšanje nasmeha.',

        admin: 'Sočutno admin',
    },
}
